import { configureStore } from '@reduxjs/toolkit';
import type { IReducerRegister, IStoreMiddlewares, IStoresData, ReducerSlice } from '../interface';

function buildStore(
    reducerRegister: IReducerRegister,
    middlewares: IStoreMiddlewares,
): IStoresData {
    const store = configureStore({
        reducer: reducerRegister.reduce,
        devTools: true,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({
                serializableCheck: false,
            }).concat(middlewares.all()),
    });

    const newSliceAdded = (slice: ReducerSlice) => {
        store.replaceReducer(reducerRegister.reduce);

        /* Initialize slice-state */
        slice.actions.reset();
    };

    reducerRegister.subscribe('SliceAdded', newSliceAdded);

    const data: IStoresData = {
        store,
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
        dispatch: (action: any) => store.dispatch(action),
    };

    return data;
}

export default buildStore;
